<style lang="stylus">
    .rightclickmenu-aiganttbox
        .ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
        floatTool_dropbox()
</style>

<template>
    <div class="rightclickmenu-aiganttbox">
        <AIFloatMenuPictureAnalysis :fromType="'rightClickMenu'" />
        <div class="ft-aigray-text" :class="{ 'ft-h-divided': !internal }">
            <p>{{ $t("ganttAi") }}</p>
        </div>
        <FtMenu
            v-for="item in aiMenu"
            :imgIcon="item.icon"
            :text="$t(item.label)"
            :key="item.label"
            :placement="'right'"
            @clickMenu="clickAiMenu(item.id, $t(item.label))"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";
    import { aiStatusType } from "@/app/components/ai3/enum";
    import FtMenu from "@/app/components/FloatTool/public/FtMenu.vue";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";

    @Component({
        components: {
            FtMenu,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiGantt extends Vue {
        aiMenu = [
            {
                id: aiStatusType.ganttSummarize,
                icon: "gantt-ai-total",
                label: "ganttTotal",
            },
            {
                id: aiStatusType.ganttProgress,
                icon: "gantt-ai-progress",
                label: "ganttProgress",
            },
            {
                id: aiStatusType.ganttRisk,
                icon: "gantt-ai-risk",
                label: "ganttRisk",
            },
            {
                id: aiStatusType.ganttExpirence,
                icon: "gantt-ai-share",
                label: "ganttShare",
            },
        ];
        clickAiMenu(id, label) {
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("aiAnalyse", id, label);
                this.aiTrackData(id);
            });
            this.$store.commit("closeContext");
        }
        aiTrackData(id) {
            let obj = {
                [aiStatusType.ganttSummarize]: "Project Overview",
                [aiStatusType.ganttProgress]: "Project Progress",
                [aiStatusType.ganttRisk]: "Risk Identification",
                [aiStatusType.ganttExpirence]: "Lessons Learned",
            };
            this.sensors.track("clickGanttAI", {
                Catalogues: "AI",
                click_type: obj[id],
            });
        }
    }
</script>
<i18n>
{
    "zh": {
        "ganttAi": "甘特图分析",
        "ganttTotal": "项目概述",
        "ganttProgress": "项目进展",
        "ganttRisk": "风险识别",
        "ganttShare": "项目经验分享"
    },
    "en": {
        "ganttAi": "Gantt Chart Analysis",
        "ganttTotal": "Project Overview",
        "ganttProgress": "Project Progress",
        "ganttRisk": "Risk Identification",
        "ganttShare": "Lessons Learned"
    },
    "fr": {
        "ganttTotal": "Aperçu du projet",
        "ganttProgress": "Avancement du projet",
        "ganttRisk": "Identificación de riesgos",
        "ganttShare": "Leçons apprises"
    },
    "de": {
        "ganttTotal": "Projektübersicht",
        "ganttProgress": "Projektfortschritt",
        "ganttRisk": "Risikoermittlung",
        "ganttShare": "Gesammelte Erfahrungen"
    },
    "jp": {
        "ganttTotal": "プロジェクトの概要",
        "ganttProgress": "プロジェクトの進行状況",
        "ganttRisk": "リスクの特定",
        "ganttShare": "得られた経験"
    },
    "es": {
        "ganttTotal": "Descripción general del proyecto",
        "ganttProgress": "Progreso del proyecto",
        "ganttRisk": "Identificación de riesgos",
        "ganttShare": "Lecciones aprendidas"
    },
    "pt": {
        "ganttTotal": "Visão geral do projeto",
        "ganttProgress": "Progresso do projeto",
        "ganttRisk": "Identificação de risco",
        "ganttShare": "Lições aprendidas"
    },
    "it": {
        "ganttTotal": "Panoramica del progetto",
        "ganttProgress": "Stato del progetto",
        "ganttRisk": "Identificazione rischio",
        "ganttShare": "Analisi di fine progetto"
    },
    "tw": {
        "ganttTotal": "專案概覽",
        "ganttProgress": "專案進度",
        "ganttRisk": "風險識別",
        "ganttShare": "專案經驗傳承"
    }
}
</i18n>
